import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Icon from '../AppIcon';
import AppLogo from '../AppLogo';
import { useCart } from '../cart/CartContext';
import { useCompany } from '../../components/context/CompanyContext';
import TrackingModal from '../../components/tracking/TrackingModal'; 

const ClientHeaderNavigation = ({ onRestartBooking }) => {
  const { openCart, items } = useCart();
  const { company } = useCompany();
  const { companyPath } = useParams();

  const [isTrackingOpen, setIsTrackingOpen] = useState(false);

  return (
    <>
      <header className="fixed top-0 left-0 right-0 z-50 bg-card shadow-sm border-b border-border">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link
              to={`/${companyPath}`}
              className="flex items-center gap-3 hover:opacity-80 transition-opacity duration-250"
              aria-label="Cute claw Salon - Home"
            >
              {company?.logoUrl ? (
                <div className="w-12 h-12 rounded-xl overflow-hidden shadow-md flex-shrink-0">
                  <img src={company.logoUrl} alt={`${company.name} logo`} className="w-full h-full object-cover" />
                </div>
              ) : (
                <AppLogo size={28} shape="rounded" bg="brand" className="shadow-md" />
              )}
              <div className="hidden sm:flex flex-col min-w-0 max-w-[520px] lg:max-w-[640px]">
                <span className="font-heading font-bold text-2xl text-foreground truncate">{company?.name || ''}</span>
                <span className="text-sm text-muted-foreground font-caption truncate overflow-hidden whitespace-nowrap">
                  {company?.description}
                </span>
              </div>
            </Link>

            <nav className="flex items-center gap-4">
              {/* Cart button */}
              <button
                onClick={openCart}
                className="relative flex items-center gap-2 px-4 py-2 hover:bg-muted rounded-lg transition-all"
              >
                <Icon name="ShoppingCart" size={20} />
                {items.length > 0 && (
                  <span className="absolute -top-1 -right-1 bg-primary text-white text-xs rounded-full px-1.5">
                    {items.length}
                  </span>
                )}
              </button>

              {/* Track order, booking, or request button */}
              <button
                onClick={() => setIsTrackingOpen(true)}
                className="flex items-center gap-2 px-4 py-2 hover:bg-muted rounded-lg transition-all duration-250 ease-elegant hover:scale-105 active:scale-95"
                aria-label="Track order, booking, or request"
              >
                <Icon name="Search" size={20} />
                <span className="hidden md:inline font-caption font-medium">Track</span>
              </button>

              {onRestartBooking && (
                <button
                  onClick={onRestartBooking}
                  className="flex items-center gap-2 px-4 py-2 text-primary hover:bg-primary/10 rounded-lg transition-all duration-250 ease-elegant hover:scale-105 active:scale-95"
                  aria-label="Start new booking"
                >
                  <Icon name="RotateCcw" size={20} />
                  <span className="hidden md:inline font-caption font-medium">New Booking</span>
                </button>
              )}

              <a
                href={`tel:${company?.phoneNumber}`}
                className="flex items-center gap-2 px-4 py-2 text-foreground hover:bg-muted rounded-lg transition-all duration-250 ease-elegant hover:scale-105 active:scale-95"
                aria-label="Call salon"
              >
                <Icon name="Phone" size={20} />
                <span className="hidden md:inline font-caption font-medium">Call Us</span>
              </a>
            </nav>
          </div>
        </div>
      </header>

      {/* Tracking modal — rendered at nav level to stay above everything */}
      <TrackingModal
        isOpen={isTrackingOpen}
        onClose={() => setIsTrackingOpen(false)}
      />
    </>
  );
};

export default ClientHeaderNavigation;
